import React from "react";
import { updateData } from "../../utility/managerApi";
import CancelIcon from "@mui/icons-material/Cancel";

function EditCustomer({
  singleData,
  setSingleData,
  fetchCustomers,
  setEdittab,
  setLoading,
  currentPage,
}) {
  const handleChange = (e) => {
    const { name, value } = e.target; // Destructure name and value from event target
    setSingleData((prevData) => ({
      ...prevData,
      [name]: value, // Update the corresponding field in state
    }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    // Log singleData before submission to check its content

    const keysToExtract = ["name", "comment", "preference"];
    const newSingleData = Object.keys(singleData).reduce((result, key) => {
      if (keysToExtract.includes(key)) {
        result[key] = singleData[key];
      }
      return result;
    }, {});

    const response = await updateData(
      "customers/update/",
      singleData.id,
      newSingleData
    );

    let errorCheck = response?.response?.data?.error;

    if (errorCheck) {
      setLoading(false);
    } else {
      fetchCustomers(currentPage);
      setEdittab(false);
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-md">
      <div className="flex justify-end">
        <CancelIcon onClick={() => setEdittab(false)} />
      </div>

      <h2 className="text-2xl font-medium text-center">Edit Category </h2>
      <form
        onSubmit={handleEditSubmit}
        className="py-12  flex flex-col justify-center items-center gap-6 "
      >
        <div className="flex flex-col gap-6 ">
          <div className="flex flex-col">
            <label htmlFor="">Name</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Category Name"
              type="text "
              name="name"
              // id="email"
              value={singleData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="">Comment</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md focus:border-gray-500 focus:outline-none lg:w-[400px]"
              placeholder="Short Description"
              type="text"
              // id="email"
              name="comment"
              value={singleData.comment}
              onChange={handleChange}
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="">Preference</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md focus:border-gray-500 focus:outline-none lg:w-[400px]"
              placeholder="Short Description"
              type="text"
              // id="email"
              name="preference"
              value={singleData.preference}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <button
          // disabled={loading}
          type="submit"
          className="px-4 py-3 text-white rounded-lg w-full lg:w-[400px] bg-blue-500"
        >
          {/* {loading ? "Saving..." : "Save Product"} */}
          Submit
        </button>
      </form>
      {/* <ToastContainer /> */}
    </div>
  );
}

export default EditCustomer;
